/**
 * Hex values for Styleable::COLORS — used for inline styles when
 * Tailwind dynamic class construction isn't possible.
 * These match the -600 shade of each Tailwind color.
 */
export const COLOR_HEX: Record<string, string> = {
  blue: "#2563eb",
  green: "#16a34a",
  purple: "#9333ea",
  orange: "#ea580c",
  indigo: "#4f46e5",
  red: "#dc2626",
  pink: "#ec4899",
  emerald: "#059669",
  yellow: "#ca8a04",
  gray: "#6b7280",
  cyan: "#0891b2",
  amber: "#d97706",
  teal: "#0d9488",
}

export function colorHex(name: string | null | undefined): string {
  return COLOR_HEX[name ?? ""] ?? COLOR_HEX.gray
}
